import { render, staticRenderFns } from "./OptinOnboardingModal.vue?vue&type=template&id=6720a39e&scoped=true"
import script from "./OptinOnboardingModal.vue?vue&type=script&lang=js"
export * from "./OptinOnboardingModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6720a39e",
  null
  
)

export default component.exports